import { useCallback } from 'react';
import { useUrlFilters } from '@/shared/hooks';
import type { EmployeesParams } from '../types';

// Роли сотрудников в системе
const EMPLOYEE_ROLES = ['root', 'privileged_pentester', 'pentester', 'client', 'it_engineer'] as const;

/**
 * Хук для работы с фильтрами сотрудников
 * Интегрирует useUrlFilters с доменной логикой сотрудников
 */
export const useEmployeesFilters = () => {
  // Мемоизируем validateValue для стабильной ссылки
  const validateValue = useCallback((filterKey: string, value: string) => {
    // Для role фильтруем только валидные значения
    if (filterKey === 'role') {
      return EMPLOYEE_ROLES.includes(value as typeof EMPLOYEE_ROLES[number]);
    }
    return true;
  }, []);

  const {
    filters,
    setFilters,
    handleApplyFilters,
    handleCancelFilters,
    handleRemoveFilter,
    getActiveFilters,
  } = useUrlFilters({
    validateValue,
    excludeFromActiveFilters: [],
  });

  // Преобразование фильтров в параметры запроса
  const toQueryParams = useCallback((): Partial<EmployeesParams> => {
    const params: Partial<EmployeesParams> = {};

    // Role из фильтров
    const roleFilters = filters['role'] || [];
    if (roleFilters.length === 1) {
      const role = roleFilters[0];
      if (EMPLOYEE_ROLES.includes(role as typeof EMPLOYEE_ROLES[number])) {
        params.role = role;
      }
    }

    return params;
  }, [filters]);

  return {
    filters,
    setFilters,
    handleApplyFilters,
    handleCancelFilters,
    handleRemoveFilter,
    getActiveFilters,
    toQueryParams,
  };
};
